'use client'
import { useEffect, useState } from 'react'

import dayjs from 'dayjs'

import 'dayjs/locale/id'

dayjs.locale('id')

const FooterContent = () => {
  const [currentTime, setCurrentTime] = useState('')

  useEffect(() => {
    setCurrentTime(dayjs().format('DD MMM YYYY HH:mm:ss'))

    const timer = setInterval(() => {
      setCurrentTime(dayjs().format('DD MMM YYYY HH:mm:ss'))
    }, 1000)

    return () => clearInterval(timer)
  }, [])

  return (
    <div className='w-full '>
      <div className='flex flex-wrap items-center justify-between gap-4 w-full'>
        <p className='text-sm sm:text-base'>
          <span className='text-textSecondary'>{`© ${new Date().getFullYear()}, Made with `}</span>
          <span>{`❤️`}</span>
          <span className='text-textSecondary'>{` by `}</span>
          <span className='font-bold text-red-600'>{`IT TMC`}</span>
        </p>
        <span suppressHydrationWarning className='text-xl sm:text-1xl md:text-2xl font-bold text-primary'>
          {currentTime}
        </span>
      </div>
    </div>
  )
}

export default FooterContent
